export default "/assets/Icon/blocto.svg"